export interface ILoggerNewSessionDTO {
  id: number;
  token: string;
}